import { createFileRoute } from "@tanstack/react-router";
import { PlaybookActivity } from "../../../components/playbooks/playbook-tabs";

/** Activity: the cases the playbook runs. */
export const Route = createFileRoute("/_authenticated/_workspace/playbooks/$playbookId/activity")({
  component: PlaybookActivity,
});
